module.exports = __webpack_public_path__ + "static/parade-2019-house20-f2a37ab87312a49fa30b24ee1c020e4e.jpg";